import {Component, OnInit} from "@angular/core";
import {CommandAsync, ICommand} from "@nahuelmorata/ngx-command";
import {ItemPreguntaDTO, PreguntaDTO} from "@DTOS";
import {ItemPreguntaModelDTO, PreguntaModelDTO} from "@Models";
import {obtenerIdPreguntaTipo, PreguntasTipoEnum} from "@shared/enums";
import {ModalService, NotificacionServiceEmisor} from "@shared/services";
import {
    EditorCondicionesComponent
} from "../../../../encuestas-detalle/editor-condiciones/editor-condiciones.component";
import {TiposPreguntasService} from "../../tipos-preguntas.service";
import {Subscription} from "rxjs";
import {debounceTime, filter, mergeMap, tap} from "rxjs/operators";
import {TipoPreguntaComponent} from "../tipo-pregunta/tipo-pregunta.component";


@Component({
    selector: "app-tipo-pregunta-salto-condicionado",
    templateUrl: "./tipo-pregunta-salto-condicionado.component.html",
    styleUrls: ["./tipo-pregunta-salto-condicionado.component.scss"]
})
export class TipoPreguntaSaltoCondicionadoComponent extends TipoPreguntaComponent implements OnInit {
    public preguntas: PreguntaDTO[];
    public pregunta: PreguntaModelDTO;
    public items: ItemPreguntaModelDTO[] = [];

    public textoItem = "";
    public colores = {};

    public agregarCmd: ICommand = new CommandAsync(() => this.agregarItem());
    public borrarCmd: ICommand = new CommandAsync((item: ItemPreguntaModelDTO) =>
        this.borrarItem(item));

    private subsItems = new Subscription();

    constructor(private tiposPreguntasService: TiposPreguntasService, private modalService: ModalService,
        private notificacionService: NotificacionServiceEmisor) {
        super();
    }

    ngOnInit(): void {
        this.pregunta = this.tiposPreguntasService.preguntaModel || new PreguntaModelDTO(new PreguntaDTO());
        this.preguntas = this.tiposPreguntasService.encuesta?.preguntas
            ?.filter(pregunta => pregunta.id !== this.pregunta.Id) ?? [];
        this.colores = this.tiposPreguntasService.colores;
        this.cargarItemsModels();
    }

    public async agregarItem(): Promise<void> {
        let itemPreguntaDTO = new ItemPreguntaDTO({
            text: this.textoItem.trim()
        });

        this.textoItem = "";
        itemPreguntaDTO = await this.tiposPreguntasService.agregarItemPregunta(this.pregunta.Entidad, itemPreguntaDTO);
        const model = this.crearItemModel(itemPreguntaDTO);
        this.items.push(model);
        this.notificacionService.notificarExito("Item agregado correctamente.");
    }

    public obtenerId(tipoPregunta: PreguntasTipoEnum): string {
        return obtenerIdPreguntaTipo(tipoPregunta);
    }

    public obtenerPreguntaPorId(idPregunta: number): PreguntaDTO {
        return this.preguntas.find(preguntaDTO => preguntaDTO.id === idPregunta) ?? new PreguntaDTO();
    }

    public abrirEditorCondiciones(item: ItemPreguntaModelDTO) {
        const modalRef = this.modalService.open(EditorCondicionesComponent, { centered: true, windowClass: "modal-condiciones" });
        modalRef.componentInstance.encuesta = this.tiposPreguntasService.encuesta;
        modalRef.componentInstance.item = item;
    }

    private cargarItemsModels() {
        this.items = this.pregunta.Items.map(item => this.crearItemModel(item));
    }

    private async borrarItem(item: ItemPreguntaModelDTO): Promise<void> {
        await this.tiposPreguntasService.borrarItemPregunta(this.pregunta.Entidad, item.Entidad);
        this.notificacionService.notificarExito("Item borrado correctamente.");
    }

    private crearItemModel(item: ItemPreguntaDTO) {
        const model = new ItemPreguntaModelDTO(item);
        this.subsItems.add(
            model.changed$.pipe(
                filter(Boolean),
                filter(() => item.texto !== ""),
                debounceTime(400),
                mergeMap(() => this.tiposPreguntasService.guardarItemPregunta(this.pregunta.Entidad, item)),
                tap(() => this.notificacionService.notificarExito("Item modificado correctamente."))
            ).subscribe()
        );
        return model;
    }
}
